import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/chatbot-integration/PageContent.tsx");
